import { type FC, useCallback } from 'react';

import { useMapAppContext } from '@/microfrontends/map/shared/context/mapAppContext';

import { useMapStoreContext } from '../../../context/mapStoreContext';

import { GeoLocation } from './GeoLocation';

export const GeoLocationContainer: FC = () => {
  const { logger } = useMapAppContext();
  const { ymaps, map } = useMapStoreContext();

  const handleClick = useCallback(() => {
    ymaps.geolocation
      .get({
        mapStateAutoApply: true,
      })
      .then(result => {
        map.geoObjects.add(result.geoObjects);
      })
      .catch(e => {
        logger.warning('Произошла ошибка во время определения геолокации пользователя', {
          domain: '@/shared/containers/GeoLocationContainer.tsx',
          errorMessage: e.message,
        });
      });
  }, [ymaps.geolocation, map.geoObjects, logger]);

  return <GeoLocation handleClick={handleClick} />;
};
